var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('h3',{staticClass:"notAllowed text-center"},[_vm._v("Su cuenta ha sido registrada. Le hemos enviado un correo de confirmación, por favor revise su email para activar su cuenta de usuario.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }